import { render } from "./RentenClearUpErklaerVideoEdit.vue?vue&type=template&id=4f85dbc0"
import script from "./RentenClearUpErklaerVideoEdit.vue?vue&type=script&lang=js"
export * from "./RentenClearUpErklaerVideoEdit.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__